import React from 'react';
import { Scrollbar } from 'smooth-scrollbar-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colorBlue, colorScrollbar } from '@/utils/palette';
import {
  sidebarClose,
  marginRight,
} from '@/utils/directions';
import SidebarContent from './SidebarContent';

const Sidebar = ({
  changeMobileSidebarVisibility, sidebarShow, collapse,
}) => (
  <SidebarWrap
    show={sidebarShow}
    collapse={collapse}
  >
    <SidebarBack
      type="button"
      aria-label="sidebar visibility"
      onClick={changeMobileSidebarVisibility}
      show={sidebarShow}
    />
    <SidebarScroll>
      <SidebarWrapper>
        <SidebarContent
          onClick={() => {}}
          collapse={collapse}
        />
      </SidebarWrapper>
    </SidebarScroll>
  </SidebarWrap>
);

Sidebar.propTypes = {
  sidebarShow: PropTypes.bool.isRequired,
  collapse: PropTypes.bool.isRequired,
  changeMobileSidebarVisibility: PropTypes.func.isRequired,
};

export default Sidebar;

// region STYLES

const SidebarWrapper = styled.div`
  display: block;

  @media screen and (min-width: 576px) {
    display: ${props => (props.topNavigation ? 'none' : 'block')};
  }
`;

const SidebarScroll = styled(Scrollbar)`
  width: 266px;
  height: calc(100vh - 60px);
  transition: width 0.3s ease;

  .scrollbar-track {
    background: transparent;

    &.scrollbar-track-y {
      width: 5px;
    }

    &.scrollbar-track-x {
      display: none !important;
    }
  }

  .scrollbar-thumb {
    width: 5px;
    opacity: 0.3;
    transition: height 0.3s;
    cursor: pointer;
    background: ${colorScrollbar};
  }
`;

const SidebarWrap = styled.div`
  position: fixed;
  bottom: 0;
  height: 100vh;
  width: 266px;
  box-shadow: 12px 0 30px rgba(12, 20, 34, 0.12);
  transition: transform 0.3s ease, width 0.3s ease;
  background:
    radial-gradient(circle at top left, rgba(255, 255, 255, 0.1), transparent 28%),
    linear-gradient(180deg, #2a507d 0%, ${colorBlue} 46%, #173150 100%);
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  top: 60px;
  padding-top: 0;
  z-index: 101;
  display: none;
  
  ${props => props.show && `
    display: block;
    transform: ${sidebarClose};
  `};

  @media screen and (min-width: 576px) {
    padding-top: 68px;
    z-index: 99;
    display: block;
    top: 0;

    ${props => props.collapse && `
      width: 64px;
      overflow: visible;
  
      ${SidebarScroll} {
        width: 64px;
        overflow: visible !important;
      }
  
      .scrollbar-track.scrollbar-track-y {
        ${marginRight(props)}: 194px;
      }
    }
  `};

  @media screen and (min-width: 1300px) {

    ${props => props.topNavigation && `
      transform: translateX(0);
      display: none;
    `}
  }

  @media screen and (max-width: 1400px) {
    ${props => props.topNavigation && 'display: none;'}
    ${props => props.topNavigation && props.show && 'display: block;'}
  }
`;

const SidebarBack = styled.button`
  width: 100vw;
  position: fixed;
  display: ${props => (props.show ? 'block' : 'none')};
  background: transparent;
  border: none;
  top: 60px;
  bottom: 0;
  
  @media screen and (min-width: 576px) {
    display: none;
  }
`;

// endregion
